import Component from '../Component';
import { fadeOut, fadeIn, hide } from '@siteparts/show-hide-effects';

// TODO: handle error on content error
class Modal extends Component {
    constructor() {
        super();

        this.key = 'modal';
        // this.id = 'modalContentPlaceholder';
        this.className = 'js-modal';

        // needed to avoid click handler from firing on fading out modal - causes bugs
        this.state = {
            closed: true,
        };
    }

    componentDidMount() {
        hide(this.component);
        this.setupEventListeners();
    }

    open() {
        // In case of switching content, do not fadeIn again
        if (this.state.closed) {
            this.state.closed = false;
            fadeIn(this.component);
        }
    }

    close() {
        this.state.closed = true;
        fadeOut(this.component);
    }

    setupEventListeners() {
        // close on clicking outside of content
        this.component.addEventListener('click', e => {
            if (e.target.matches(`.${this.className}`) && !this.state.closed) {
                this.dispatchCustomEvent('close-modal');
            }
        });
    }

    render() {
        return `
            <div ref="component-${this.key}" class="modal ${this.className}">
            </div>
        `;
    }
}

export default Modal;